module.exports = __webpack_public_path__ + "media/images/app/header/search-eb195d8d00be41c2a4f6cc7b0099aff0.svg";